// extracted by mini-css-extract-plugin
export var button = "_bx-7";
export var buttonRow = "_bx-6";
export var fadeIn = "_bx-1";
export var gradient = "_bx-0";
export var panel = "_bx-2";
export var panelIn = "_bx-3";
export var subtitle = "_bx-5";
export var title = "_bx-4";